/* Lightbox dos sabores (foto / vídeo / tabela) — v3
   Correções mobile: abre ao tocar em qualquer ponto da mídia do card,
   vídeo com autoplay confiável (muted + playsinline + retry), botão de play
   quando o navegador bloqueia autoplay (Modo Economia de Energia, etc.),
   sem conflito com o lightbox antigo do box-builder. */
(function () {
  'use strict';

  var CSS =
    '.flavor-lightbox{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center}' +
    '.flavor-lightbox[hidden]{display:none}' +
    '.flavor-lightbox-backdrop{position:absolute;inset:0;background:rgba(46,30,15,.6)}' +
    '.flavor-lightbox-panel{position:relative;background:var(--surface,#fff);border-radius:16px;box-shadow:0 24px 64px rgba(0,0,0,.35);padding:14px 14px 34px;max-width:min(92vw,620px);max-height:92vh;width:max-content}' +
    '.flavor-lightbox-stage{position:relative;display:flex;align-items:center;justify-content:center}' +
    '.flavor-lightbox-img,.flavor-lightbox-video{max-width:100%;max-height:calc(92vh - 60px);object-fit:contain;display:block;margin:0 auto;transition:opacity .25s ease}' +
    '.flavor-lightbox-img.is-switching,.flavor-lightbox-video.is-switching{opacity:0}' +
    '.flavor-lightbox-video{width:100%;min-width:min(60vw,480px);background:#000;border-radius:8px}' +
    '.flavor-lightbox-play{position:absolute;left:50%;top:50%;width:72px;height:72px;margin:-36px 0 0 -36px;border:0;border-radius:50%;background:rgba(255,255,255,.92);color:#5c3f22;box-shadow:0 12px 30px rgba(0,0,0,.35);cursor:pointer;display:none;align-items:center;justify-content:center}' +
    '.flavor-lightbox-play.is-visible{display:flex}' +
    '.flavor-lightbox-play svg{width:30px;height:30px;margin-left:4px}' +
    '.flavor-lightbox-nav,.flavor-lightbox-close{border:0;cursor:pointer;display:flex;align-items:center;justify-content:center;background:var(--surface,#fff);box-shadow:var(--shadow-md,0 12px 35px rgba(0,0,0,.12));color:var(--terra-700,#5c3f22);position:absolute;border-radius:50%;-webkit-tap-highlight-color:transparent}' +
    '.flavor-lightbox-nav{top:50%;transform:translateY(-50%);width:44px;height:44px;font-size:26px;line-height:1}' +
    '.flavor-lightbox-nav.is-prev{left:-14px}.flavor-lightbox-nav.is-next{right:-14px}' +
    '.flavor-lightbox-close{top:-14px;right:-14px;width:40px;height:40px;font-size:22px;z-index:2}' +
    '.flavor-lightbox-dots{position:absolute;bottom:12px;left:50%;transform:translateX(-50%);display:flex;gap:8px}' +
    '.flavor-lightbox-dots button{width:10px;height:10px;border-radius:50%;border:0;padding:0;cursor:pointer;background:var(--neutro-300,#d3ccc2)}' +
    '.flavor-lightbox-dots button.is-active{background:var(--folha-600,#6fa82c)}' +
    'body.flavor-lightbox-open{overflow:hidden}' +
    '.flavor-media,.flavor-product,.flavor-table,.flavor-video{cursor:pointer}' +
    '@media(max-width:640px){.flavor-lightbox-panel{max-width:94vw;padding:10px 10px 30px}.flavor-lightbox-nav{width:40px;height:40px}.flavor-lightbox-nav.is-prev{left:4px}.flavor-lightbox-nav.is-next{right:4px}.flavor-lightbox-close{top:-12px;right:-12px}}';

  var root, img, video, playBtn, dotsWrap, dots = [], prevBtn, nextBtn, closeBtn, panel;
  var slides = [], index = 0, lastFocus = null, switchTimer = null;

  function isTouch() {
    try { return window.matchMedia && (window.matchMedia('(hover: none)').matches || window.matchMedia('(pointer: coarse)').matches); }
    catch (e) { return false; }
  }

  function build() {
    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    root = document.createElement('div');
    root.className = 'flavor-lightbox';
    root.hidden = true;

    var backdrop = document.createElement('div');
    backdrop.className = 'flavor-lightbox-backdrop';

    panel = document.createElement('div');
    panel.className = 'flavor-lightbox-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Mídia ampliada');

    closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'flavor-lightbox-close';
    closeBtn.setAttribute('aria-label', 'Fechar');
    closeBtn.textContent = '×';

    var stage = document.createElement('div');
    stage.className = 'flavor-lightbox-stage';

    img = document.createElement('img');
    img.className = 'flavor-lightbox-img';
    img.alt = '';

    video = document.createElement('video');
    video.className = 'flavor-lightbox-video';
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.autoplay = true;
    video.preload = 'auto';
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.controls = false;
    video.style.display = 'none';

    playBtn = document.createElement('button');
    playBtn.type = 'button';
    playBtn.className = 'flavor-lightbox-play';
    playBtn.setAttribute('aria-label', 'Reproduzir vídeo');
    playBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';

    prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'flavor-lightbox-nav is-prev';
    prevBtn.textContent = '‹';

    nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'flavor-lightbox-nav is-next';
    nextBtn.textContent = '›';

    dotsWrap = document.createElement('div');
    dotsWrap.className = 'flavor-lightbox-dots';

    stage.appendChild(img);
    stage.appendChild(video);
    stage.appendChild(playBtn);
    panel.appendChild(closeBtn);
    panel.appendChild(stage);
    panel.appendChild(prevBtn);
    panel.appendChild(nextBtn);
    panel.appendChild(dotsWrap);
    root.appendChild(backdrop);
    root.appendChild(panel);
    document.body.appendChild(root);

    backdrop.addEventListener('click', close);
    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { go(index - 1, true); });
    nextBtn.addEventListener('click', function () { go(index + 1, true); });

    // Play manual: usado quando o navegador bloqueia o autoplay.
    playBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      tryPlay(true);
    });
    video.addEventListener('click', function () {
      if (video.paused) tryPlay(true); else video.pause();
    });
    video.addEventListener('play', function () { playBtn.classList.remove('is-visible'); });
    video.addEventListener('playing', function () { playBtn.classList.remove('is-visible'); });
    video.addEventListener('pause', function () { if (!root.hidden && video.style.display !== 'none') playBtn.classList.add('is-visible'); });
    video.addEventListener('loadedmetadata', function () { if (video.paused && !root.hidden) tryPlay(false); });
    video.addEventListener('canplay', function () { if (video.paused && !root.hidden) tryPlay(false); });
    video.addEventListener('error', function () {
      // Se a fonte falhar, mostra o botão para o usuário tentar de novo (recarrega a fonte).
      playBtn.classList.add('is-visible');
    });

    document.addEventListener('keydown', function (e) {
      if (root.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') go(index - 1, true);
      if (e.key === 'ArrowRight') go(index + 1, true);
    });

    // Swipe (mobile)
    var startX = null, startY = null;
    panel.addEventListener('touchstart', function (e) {
      startX = e.changedTouches[0].clientX;
      startY = e.changedTouches[0].clientY;
    }, { passive: true });
    panel.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      startX = startY = null;
      if (Math.abs(dx) < 40 || Math.abs(dy) > Math.abs(dx)) return;
      go(dx > 0 ? index - 1 : index + 1, true);
    }, { passive: true });

    // Trap de foco
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = [closeBtn, prevBtn, nextBtn, playBtn].concat(dots).filter(function (el) { return el.offsetParent !== null; });
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  function tryPlay(fromGesture) {
    if (!video || video.style.display === 'none') return;
    video.muted = true;
    var p;
    try { p = video.play(); } catch (e) { p = null; }
    if (p && p.then) {
      p.then(function () {
        playBtn.classList.remove('is-visible');
      }).catch(function () {
        // Autoplay bloqueado (ex.: Modo Economia de Energia no iOS): mostra o play
        // e, se foi um toque do usuário, libera os controles nativos como plano B.
        playBtn.classList.add('is-visible');
        if (fromGesture) video.controls = true;
      });
    }
  }

  function stopVideo() {
    try { video.pause(); video.removeAttribute('src'); video.load(); } catch (e) {}
    video.controls = false;
    playBtn.classList.remove('is-visible');
  }

  function renderDots() {
    dotsWrap.innerHTML = '';
    dots = [];
    slides.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-slide', String(i));
      b.setAttribute('aria-label', s.label);
      b.addEventListener('click', function () { go(i, true); });
      dotsWrap.appendChild(b);
      dots.push(b);
    });
  }

  function show() {
    var s = slides[index];
    if (s.type === 'video') {
      img.style.display = 'none';
      video.style.display = '';
      video.controls = false;
      if (video.getAttribute('src') !== s.src) {
        video.setAttribute('src', s.src);
        video.load();
      }
      tryPlay(false);
    } else {
      stopVideo();
      video.style.display = 'none';
      img.style.display = '';
      img.src = s.src;
      img.alt = s.alt;
    }
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    var n = slides.length;
    if (n > 1) {
      prevBtn.setAttribute('aria-label', slides[(index - 1 + n) % n].label);
      nextBtn.setAttribute('aria-label', slides[(index + 1) % n].label);
    }
    var multi = n > 1;
    prevBtn.style.display = multi ? '' : 'none';
    nextBtn.style.display = multi ? '' : 'none';
    dotsWrap.style.display = multi ? '' : 'none';
  }

  function go(i, animate) {
    if (!slides.length) return;
    index = (i + slides.length) % slides.length;
    if (!animate) { show(); return; }
    clearTimeout(switchTimer);
    img.classList.add('is-switching');
    video.classList.add('is-switching');
    switchTimer = setTimeout(function () {
      show();
      img.classList.remove('is-switching');
      video.classList.remove('is-switching');
    }, 130);
  }

  function open(list, start, trigger) {
    if (!root) build();
    slides = list;
    renderDots();
    lastFocus = trigger || document.activeElement;
    root.hidden = false;
    document.body.classList.add('flavor-lightbox-open');
    go(start, false);
    // No mobile o foco no botão de fechar pode rolar a página; só foca com teclado/mouse.
    if (!isTouch()) closeBtn.focus();
  }

  function close() {
    if (!root || root.hidden) return;
    stopVideo();
    root.hidden = true;
    document.body.classList.remove('flavor-lightbox-open');
    if (lastFocus && lastFocus.focus && !isTouch()) lastFocus.focus();
  }

  function srcOf(el) {
    if (!el) return '';
    if (el.getAttribute('src')) return el.getAttribute('src');
    var source = el.querySelector('source');
    return (source && source.getAttribute('src')) || '';
  }

  function wire(scope) {
    var cards = (scope || document).querySelectorAll('[data-flavor-card]');
    Array.prototype.forEach.call(cards, function (card) {
      if (card.dataset.lightboxWired === 'true') return;
      card.dataset.lightboxWired = 'true';

      var media = card.querySelector('.flavor-media');
      var photo = card.querySelector('.flavor-product');
      var table = card.querySelector('.flavor-table');
      var name = card.dataset.flavorName || 'Produto';

      function collect() {
        var list = [], photoAt = -1, videoAt = -1, tableAt = -1;
        if (photo) { photoAt = list.length; list.push({ type: 'image', src: photo.currentSrc || photo.src, alt: name, label: 'Foto de ' + name }); }
        // O vídeo do card pode ter sido removido no mobile pelo box-builder; a URL fica no data-attribute.
        var cardVideo = card.querySelector('.flavor-video');
        var vsrc = srcOf(cardVideo) || card.getAttribute('data-flavor-video-url') || '';
        if (vsrc) { videoAt = list.length; list.push({ type: 'video', src: vsrc, alt: 'Vídeo de ' + name, label: 'Vídeo de ' + name }); }
        if (table) { tableAt = list.length; list.push({ type: 'image', src: table.currentSrc || table.src, alt: 'Tabela nutricional de ' + name, label: 'Tabela nutricional de ' + name }); }
        return { list: list, photoAt: photoAt, videoAt: videoAt, tableAt: tableAt };
      }

      function openFrom(e) {
        // Botões do card (tabela, "ver vídeo") continuam com o comportamento próprio.
        if (e.target.closest && e.target.closest('button')) return;
        e.preventDefault();
        e.stopPropagation();
        var c = collect();
        if (!c.list.length) return;
        var start;
        if (media && media.classList.contains('show-table') && c.tableAt !== -1) start = c.tableAt;
        else if (isTouch() && c.videoAt !== -1) start = c.videoAt;
        else if (e.target.classList && e.target.classList.contains('flavor-video') && c.videoAt !== -1) start = c.videoAt;
        else start = c.photoAt !== -1 ? c.photoAt : 0;
        open(c.list, start, e.currentTarget);
      }

      // Um único handler na área inteira da mídia: toque em qualquer ponto abre o lightbox.
      (media || photo).addEventListener('click', openFrom, true);
    });
  }

  function init() { wire(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) { wire(e.target); });
})();
